export function assertError(error: unknown): error is Error {
    return Boolean(error instanceof Error && error.message);
}

export function parseErrorMessage(error: unknown) {
    if (assertError(error)) return error.message;

    if (Array.isArray(error) && error.every(assertError)) {
        return error.map(({ message }) => message).join(' / ');
    }

    return typeof error === 'string' ? error : 'An unknown error has occurred';
}
